"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Box_1 = __importDefault(require("@mui/material/Box"));
var PopupText_1 = __importDefault(require("atomicComponents/molecules/Tooltips/PopupText"));
var RechargedCustomerSelect_1 = __importDefault(require("./RechargedCustomerSelect"));
var RechargedCustomerCell = function (_a) {
    var _b, _c, _d;
    var item = _a.item;
    return ((_c = (_b = item.rechCustomer) === null || _b === void 0 ? void 0 : _b.crawledMigrationCustomer) === null || _c === void 0 ? void 0 : _c.confirmedOn)
        ? (0, jsx_runtime_1.jsx)(Box_1.default, __assign({ pl: 1.75 }, { children: (0, jsx_runtime_1.jsx)(PopupText_1.default, { message: (_d = item.rechCustomer) === null || _d === void 0 ? void 0 : _d.name }) }))
        : (0, jsx_runtime_1.jsx)(RechargedCustomerSelect_1.default, { item: item });
};
exports.default = RechargedCustomerCell;
